import React, { useEffect } from 'react'
import { Layout, Form, Input, Button, message, Row, Col } from 'antd'
import { useHistory } from 'react-router-dom'
import * as utils from '../../utils'
import * as requests from '../../requests'
const { Header, Content } = Layout;

export default function Login() {
  const history = useHistory()
  useEffect(() => {
    utils.getSession().then(() => {
      console.info("User is already logged in pushing him to the home page")
      history.push("/")
    }).catch(err => {
      console.error("User is not logged in :: ", err)
    })
  }, [history])

  const onFinish = (values: any) => {
    requests.login(values.username, values.password).then(response => {
      if (response.success) {
        console.log("Login successful, redirecting to the home page")
        history.push("/")
      } else {
        message.error("Error while logging in please try again", 2)
      }
    }).catch(err => {
      console.error('Error in making an api call :: ', err)
    })
  };

  const onFinishFailed = (errors: any) => {
    console.log("Errors :: ", errors)
    message.error("Please enter valid details", 2)
  };

  return (
    <Layout>
      <Content>
        <div style={{ margin: "10px", minHeight: "100vh", paddingTop: "25vh" }}>
          <Row align="middle" justify='center'>
            <Col span={5}>
              <div style={{ boxShadow: "0 0 5px #ccc", padding: 25, background: "#fff", borderRadius: 10, textAlign: "center" }}>
                <h2>Live Console Sign In</h2>
                <Form
                  name="basic"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  size="middle"
                  layout='vertical'
                >
                  <Form.Item
                    name="username"
                    label="Username"
                    style={{ width: "100%" }}
                    rules={[{ required: true, message: 'Please input your username!' }]}
                  >
                    <Input placeholder='Username' />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    style={{ width: "100%" }}
                    rules={[{ required: true, message: 'Please input your password!' }]}
                  >
                    <Input.Password placeholder='Password' />
                  </Form.Item>
                  <Form.Item style={{ width: "30%", margin: "0 auto" }}>
                    <Button type="primary" htmlType="submit" style={{ borderRadius: "3px", display: "block", width: "100%" }}>
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  )
}
